import React, { useState } from 'react';
import styled from 'styled-components';

import { State } from 'src/state/ducks';

import StyleConfig from 'src/constants/StyleConfig';

import SingleInputFormBlock from 'src/components/molecules/form/SingleInputFormBlock';
import Button, { LinkButton } from 'src/components/atoms/button/Button';
import RadioInputBlock from 'src/components/molecules/form/RadioInputBlock';
import { ValidateMessageIfError } from 'src/components/atoms/form/ErrorMessage';

type Tag = State['master']['tags'][number];
type Props = {
  tag: Tag;
  errors: State['master']['validationErrors'];
  onSubmit: (query: Tag) => void;
};

const HashtagEditForm = (props: Props) => {
  const { tag, errors, onSubmit } = props;
  const [name, setName] = useState(tag.name);
  const [isPublished, setIsPublished] = useState(tag.is_published);
  const [isDeleted, setIsDeleted] = useState(tag.is_deleted);
  return (
    <Form>
      <div className="item">
        <SingleInputFormBlock
          isRequired
          labelName="ID"
          inputType="text"
          inputValue={tag.id}
          onChange={() => {}}
          placeholder="タグID"
          isError={false}
          isDisabeld
        />
      </div>
      <div className="item">
        <SingleInputFormBlock
          isRequired
          labelName="名前"
          inputType="text"
          inputValue={name}
          onChange={setName}
          placeholder="タグ名"
          isError={false}
        />
        <ValidateMessageIfError marginVertical={8} messages={errors.name} />
      </div>
      <div className="item">
        <RadioInputBlock
          isRequired
          labelName="公開・非公開"
          id="published"
          name="published"
          value={isPublished ? '公開' : '非公開'}
          onValue="公開"
          offValue="非公開"
          onChange={(value) => {
            setIsPublished(value === '公開');
          }}
        />
        <ValidateMessageIfError marginVertical={8} messages={errors.is_published} />
      </div>
      <div className="item">
        <RadioInputBlock
          isRequired
          labelName="削除"
          id="deleted"
          name="deleted"
          value={isDeleted ? '削除' : '削除しない'}
          onValue="削除"
          offValue="削除しない"
          onChange={(value) => {
            setIsDeleted(value === '削除');
          }}
        />
        <ValidateMessageIfError marginVertical={8} messages={errors.is_deleted} />
      </div>
      <div className="submit">
        <div className="submit-item">
          <Button
            type="button"
            isDisabled={false}
            clickEvent={() => {
              onSubmit({
                ...tag,
                name,
                is_deleted: isDeleted,
                is_published: isPublished,
              });
            }}
            text="保存する"
          />
        </div>
        <div className="submit-item mt20">
          <LinkButton
            isDisabled={false}
            buttonColor="white"
            url="/admin/master/tags"
            text="ハッシュタグ一覧へ"
          />
        </div>
      </div>
    </Form>
  );
};

const Form = styled.form`
  > .item {
    margin: ${StyleConfig.HELPER.M24} auto;
  }
  .mt8 {
    margin-top: ${StyleConfig.HELPER.M8};
  }
  > .submit {
    padding: ${StyleConfig.HELPER.M24} 0 ${StyleConfig.HELPER.M48} 0;
    .mt20 {
      margin-top: ${StyleConfig.HELPER.M20};
    }
  }
`;

export default HashtagEditForm;
